import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {User} from '../../shared/data-objects/user';
import {LoginService} from '../../shared/services/login.service';
import {SelectItem} from 'primeng/primeng';
import {HttpErrorResponse} from '@angular/common/http';
import {MessageService} from 'primeng/api';
import { FeatureToggle } from '../../shared/data-objects/feature-toggle';
import { FeatureToggleService } from '../../shared/services/feature-toggle.service';


@Component({
  selector: 'app-my-team',
  templateUrl: './my-team.component.html',
  styleUrls: ['./my-team.component.css'],
  // encapsulation: ViewEncapsulation.None,
  providers: [MessageService]
})
export class MyTeamComponent implements OnInit {
  users: User[];
  noUsersFound: boolean;
  /*
  newUsers: User[];
  noNewUsersFound: boolean;
  approvedUsers: User[];
  noApprovedUsersFound: boolean;
  internalUsers: User[];
  noInternalUsersFound: boolean;
  */
  isRequesting: boolean;
  userRoles: SelectItem[];
  stacked: boolean = false;

  showAccDialog: boolean = false;
  accountnumberModel: any = {};
  accountDialogStage: number = 1;
  accDialogErrMsg: string = '';
  accountDetails: any = null;
  accValidationInProgress: boolean = false;
  dialogMode: '' | 'approve' | 'edit' = '';

  _feature: FeatureToggle;

  newUsers: User[];
  noNewUsers: boolean;
  newRegistrations: User[];
  noNewRegistrations: boolean;
  approvedUsers: User[];
  noApprovedUsers: boolean;
  internalUsers: User[];
  noInternalUsers: boolean;
  disabledUsers: User[];
  noDisabledUsers: boolean;

  selectedTabLeftIcons: string[] = ['pi pi-users', '', '', ''];
  selectedTabStyle: any[] = [
    { 'background': 'white', 'fontWeight': 'bold' },
    { 'background': 'lightgrey', 'fontWeight': 'normal' },
    { 'background': 'lightgrey', 'fontWeight': 'normal' },
    { 'background': 'lightgrey', 'fontWeight': 'normal' }
  ];

  selectedTabIndex: number = 0;

  constructor(private loginService: LoginService, private messageService: MessageService,
    private featureToggleService: FeatureToggleService) {
  }

  ngOnInit() {
    if (this.loginService.isAdminUserLoggedIn()) {
      this.userRoles = [
        {label: 'User', value: 'User'},
        {label: 'Administrator', value: 'Administrator'}
      ];
    } else if (this.loginService.isSystemAdminUserLoggedIn()) {
      this.userRoles = [
        {label: 'User', value: 'User'},
        {label: 'Administrator', value: 'Administrator'},
        {label: 'System Administrator', value: 'System Administrator'},
        {label: 'Technical CSO', value: 'Technical CSO'}
    ];
    } else {
      this.userRoles = [
        {label: 'User', value: 'User'}];
    }

    this.refresh();
    this.getFeatureToggle();
    this.loginService.refreshToken();
  }

  async getFeatureToggle() {
    this._feature = this.featureToggleService.features;
    if (!this._feature) {
      await this.featureToggleService.fetchFeatureToggles();
      this._feature = this.featureToggleService.features;
    }

    console.log(this._feature);
  }

  refresh() {
    this.isRequesting = true;
    this.loginService.getMyUsers().subscribe((users: User[]) => {
      this.isRequesting = false;

      if (users == null || users.length === 0) {
        this.users = [];
        // this.noUsersFound = true;
      } else {
        this.users = users.filter((u: User) => {
          return u.username !== this.loginService.getUser().username;
        });
        for (let i = 0; i < this.users.length; i++) {
          this.users[i] = new User(this.users[i]);
          this.users[i]['updateErrorMessage'] = '';
        }
        this.noUsersFound = this.users.length <= 0;
        this.groupUsersByStatus();
      }

      this.groupUsersByStatus();
    }, err => {
      this.isRequesting = false;

    });
  }

  handleTabChange(e: any) {
    const index: number = e.index;
    this.selectedTabIndex = index;

    if (index === 0) {
      this.selectedTabLeftIcons = ['pi pi-users', '', '', ''];
      this.selectedTabStyle = [
        { 'background': 'white', 'fontWeight': 'bold' },
        { 'background': 'lightgrey', 'fontWeight': 'normal' },
        { 'background': 'lightgrey', 'fontWeight': 'normal' },
        { 'background': 'lightgrey', 'fontWeight': 'normal' },
      ];
    }
    if (index === 1) {
      this.selectedTabLeftIcons = ['', 'pi pi-users', '', ''];
      this.selectedTabStyle = [
        { 'background': 'lightgrey', 'fontWeight': 'normal' },
        { 'background': 'white', 'fontWeight': 'bold' },
        { 'background': 'lightgrey', 'fontWeight': 'normal' },
        { 'background': 'lightgrey', 'fontWeight': 'normal' },
      ];
    }
    if (index === 2) {
      this.selectedTabLeftIcons = ['', '', 'pi pi-users', ''];
      this.selectedTabStyle = [
        { 'background': 'lightgrey', 'fontWeight': 'normal' },
        { 'background': 'lightgrey', 'fontWeight': 'normal' },
        { 'background': 'white', 'fontWeight': 'bold' },
        { 'background': 'lightgrey', 'fontWeight': 'normal' },
      ];
    }
    if (index === 3) {
      this.selectedTabLeftIcons = ['', '', '', 'pi pi-users'];
      this.selectedTabStyle = [
        { 'background': 'lightgrey', 'fontWeight': 'normal' },
        { 'background': 'lightgrey', 'fontWeight': 'normal' },
        { 'background': 'lightgrey', 'fontWeight': 'normal' },
        { 'background': 'white', 'fontWeight': 'bold' }
      ];
    }
  }

  groupUsersByStatus(user?: User) {
    if (user) {
      const idx: number = this.users.map(u => u.username).indexOf(user.username);
      if (idx >= 0) {
        this.users[idx] = user;
      }
    }

    const hasFirstName = (u: any) => [null, undefined, ''].indexOf(u.firstName) === -1;
    const hasRegToken = (u: any) => [null, undefined, ''].indexOf(u.registrationToken) === -1;

    this.newUsers = this.users.filter(u => hasFirstName(u) && !!u.isNewAccount);
    this.noNewUsers = this.newUsers.length === 0;

    this.newRegistrations = this.users.filter(u => hasRegToken(u));
    this.noNewRegistrations = this.newRegistrations.length === 0;
    // console.log(`new registrations`, this.newRegistrations);

    this.approvedUsers = this.users.filter(u => hasFirstName(u) && !u.isNewAccount && !!u.approved && ['sysadmin', 'techcso'].indexOf((u.userRole || '').toLowerCase()) === -1);
    this.noApprovedUsers = this.approvedUsers.length === 0;

    this.internalUsers = this.users.filter(u => hasFirstName(u) && !u.isNewAccount && !!u.approved && ['sysadmin', 'techcso'].indexOf((u.userRole || '').toLowerCase()) > -1);
    this.noInternalUsers = this.internalUsers.length === 0;

    this.disabledUsers = this.users.filter(u => hasFirstName(u) && !u.isNewAccount && u.approved === false);
    this.noDisabledUsers = this.disabledUsers.length === 0;
  }

  changed(user: User) {
    user['updateErrorMessage'] = '';

    this.loginService.updateUser(user, false, this.updateUserOkCb.bind(this), this.updateUserErrorCb.bind(this));

    this.selectedTabIndex === 0 ? this.refresh() : this.groupUsersByStatus(user);
  }

  isStructuredPostalExistsForUser(user: any) {
    return (user.structuredPostal && Object.keys(user.structuredPostal).length > 0);
  }

  isStructuredPostalResidentialAddress(structuredPostal: any) {
    return !(!!structuredPostal.poBox);
  }

  validateApproval(user) {
    const validateAccountnumber = () => {
      const an = user.accountNumber;
      if (an) {

      }
    };
  }

  approveUser(user) {
    if (this.accountDetails) {
      user.approved = true;
      user.accountNumber = this.accountnumberModel.accountNumber;
      user.companyName = this.accountDetails.accountName || '';   // update company name from CCS
      this.changed(user);

      // this.showAccDialog = false;
      setTimeout(() => this.onCloseAccountModal(true), 500);

    } else {
      this.accDialogErrMsg = `Please validate account before approving.`;
    }
  }

  approve(user: User) {
    // disabled guest users: true => new feature / old feature
    if (this._feature.DisableGuestUsers) {
      this.dialogMode = 'approve';

      if (user) {
        user.approved = !user.approved;

        if (user.approved) {
          user.approved = !user.approved;
          this.changed(user);
        } else {
          if (user.accountNumber) {
            user.approved = !user.approved;
            this.changed(user);

            if (this.showAccDialog) {
              this.showAccDialog = false;
              // this.refresh();
              this.groupUsersByStatus(user);
            }
          } else {
            this.showAccDialog = true;
            this.accountnumberModel = user;
          }
        }
      }
    } else {
      user.approved = !user.approved;
      this.changed(user);
    }
  }

  updateUserOkCb(ok: boolean, user: User): void {
    user['updateErrorMessage'] = ok ? '' : 'Server Error';
    this.showAccDialog = false;
    this.messageService.add({severity: 'success', summary: 'Success', detail: `User details for ${user.username} updated successfully.`});
    this.groupUsersByStatus(user);
  }

  updateUserErrorCb(err: HttpErrorResponse, user: User): void {
    if (err) {
      user['updateErrorMessage'] = err.message;
      this.messageService.add({severity: 'error', summary: 'Error', detail: `${err.message}`});
    } else {
      user['updateErrorMessage'] = 'Server Error';
      this.messageService.add({severity: 'error', summary: 'Error', detail: `Error while updating user. Please try again.`});
    }

  }

  onCloseAccountModal(refresh?: boolean) {
    if (refresh) {
      this.refresh();
    }
    this.accountnumberModel = {};
    this.accountDialogStage = 1;
    this.showAccDialog = false;
    this.accDialogErrMsg = '';
    this.accountDetails = null;
    this.dialogMode = '';
  }

  getRole(role) {
    let _role: string = '';

    switch ((role || '').toLowerCase()) {
      case 'admin':
        _role = 'Administrator'; break;
      case 'sysadmin':
        _role = 'System Administrator'; break;
      case 'techcso':
        _role = 'Technical CSO'; break;
      case 'user':
        _role = 'User'; break;
      default:
        _role = _role; break;
    }

    return _role;
  }

  inputAccountDetails() {
    this.accountDialogStage = 2;
  }
  gotoAccountDetails() {
    this.accountDialogStage = 1;
  }

  saveAccountDetails(user) {
    this.approve(user);
  }

  getUserAccountNumber() {
    const _userAN = this.loginService.getUser().accountNumber;
    this.accountnumberModel.accountNumber = _userAN;
  }

  async validteAccountNumber() {
    this.accValidationInProgress = true;
    this.accountDetails = null;

    const _an = this.accountnumberModel.accountNumber;

    if (_an) {
      this.accDialogErrMsg = '';
      this.loginService.verifyAccount(_an).subscribe(data => {
        this.accValidationInProgress = false;
        this.accountDetails = data;
      }, err => {
        this.accDialogErrMsg = `Error while validating account number. Please try again`;
        this.accValidationInProgress = false;
        this.accountDetails = null;
      });
    } else {
      this.accValidationInProgress = false;
      this.accDialogErrMsg = 'Please enter valid account number.';
      this.accountDetails = null;
    }
  }

  edit(user) {
    this.dialogMode = 'edit';
    this.showAccDialog = true;
    this.accountnumberModel = user;
  }

  saveOnEdit(user) {
    if (user.accountNumber) {
      if (this.accountDetails) {
        user.companyName = this.accountDetails.accountName || '';   // update company name from CCS
        this.changed(user);
      } else {
        this.accDialogErrMsg = `Please validate account number before updating.`;
      }
    } else {
      this.accDialogErrMsg = `Please enter valid account number.`;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/manage-users/my-team/my-team.component.ts